// extracted by mini-css-extract-plugin
export var container = "_c2-1";
export var cornerButtonContainer = "_c2-6";
export var disabled = "_c2-2";
export var dragActive = "_c2-3";
export var fileContainer = "_c2-5";
export var hiddenInput = "_c2-4";
export var widthContainer = "_c2-0";